export default "__VITE_ASSET__FXe5koOX__"